<template>
  <div class="auth-grid">
    <div>
      <div class="card-body" style="padding: 50px 120px;">
        <slot></slot>
      </div>
    </div>
    <div class="form_intro">
      <div class="form_intro_inner">
        <img src="/images/apicenter-white-logo.svg" alt="apicenter logo" class="logo form_logo">
        <div class="form_screen"></div>
        <p>{{ trans('auth.intro') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthLayout"
}
</script>
